module.exports = __webpack_public_path__ + "static/1296507353.d9d0de5e.jpg";